import React, { useEffect, useState, useRef } from "react";
import "./syncLyrics.scss";
import useInputKeys from "hooks/useInputKeys";

const SyncLyrics = ({ data, currentTimeAudio }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(null);
  const [autoScroll, setAutoScroll] = useState(true);
  const [isAutoScroling, setIsAutoScroling] = useState(false);
  const [targetTopScroll, setTargetTopScroll] = useState(0);
  const lyricsContainerRef = useRef(null);

  const { direction, setManualCurrentTimeMusic, expand } = useInputKeys();

  useEffect(() => {
    for (let i = 0; i < data.length; i++) {
      if (
        currentTimeAudio >= data[i].startTime &&
        currentTimeAudio < data[i].endTime
      ) {
        setCurrentTextIndex(i);
        break;
      }
    }
  }, [data, currentTimeAudio]);

  useEffect(() => {
    if (currentTextIndex !== null && lyricsContainerRef.current && autoScroll) {
      const activeElement =
        lyricsContainerRef.current.children[currentTextIndex];
      const elementOffsetTop = activeElement.offsetTop - ((expand)?225:0);
      setIsAutoScroling(true);
      setTargetTopScroll(elementOffsetTop);
      lyricsContainerRef.current.scrollTo({
        top: elementOffsetTop,
        behavior: "smooth",
      });
    }
  }, [currentTextIndex, autoScroll, expand]);

  const handleScroll = (event) => {
    if (isAutoScroling) {
      if (event.target.scrollTop === targetTopScroll) {
        setIsAutoScroling(false);
        setTargetTopScroll(-1);
      }
      return;
    }
    setAutoScroll(false);
  };

  return (
    <div
      onScroll={handleScroll}
      onTouchStart={() => setAutoScroll(false)}
      className={`sync-lyrics ${
        direction === "rtl" ? "right" : "left"
      }-sync-lyrics`}
      ref={lyricsContainerRef}
    >
      {data.map((textObject, index) =>
        textObject.type === "spacer" ? (
          <div>&nbsp;</div>
        ) : (
          <p
            key={index}
            className={
              index === currentTextIndex ? "active-lyric" : "deactive-lyric"
            }
            onClick={() => {
              setManualCurrentTimeMusic(textObject.startTime);
              setAutoScroll(true);
            }}
          >
            {textObject.type === "music" ? (
              <p
                className={`animation-music ${
                  index === currentTextIndex ? "active-lyric" : "deactive-lyric"
                }`}
              >
                <span
                  style={{
                    opacity: Math.max(
                      0.3,
                      (currentTimeAudio - textObject.startTime) /
                        (textObject.duration / 3)
                    ),
                  }}
                >
                  ♫
                </span>
                <span
                  style={{
                    opacity: Math.max(
                      0.3,
                      (currentTimeAudio - textObject.startTime) /
                        (textObject.duration / 3) -
                        1
                    ),
                  }}
                >
                  ♫
                </span>
                <span
                  style={{
                    opacity: Math.max(
                      0.3,
                      (currentTimeAudio - textObject.startTime) /
                        (textObject.duration / 3) -
                        2
                    ),
                  }}
                >
                  ♫
                </span>
              </p>
            ) : (
              textObject.text
            )}
          </p>
        )
      )}
      <div className="bottom-gradient-blur">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default SyncLyrics;
